export interface BoxIdParsed {
    tournamentId: string | null;
    countryId: string | null;
    sportId: string | null;
}
export function parseBoxId(boxId: string): BoxIdParsed {
    const tokens = boxId.split('-');
    return {
        tournamentId: tokens[3] || null,
        countryId: tokens[2] || null,
        sportId: tokens[1] || null
    };
}
